export let AvailabilityType = /*#__PURE__*/function (AvailabilityType) {
  AvailabilityType["ALWAYS_AVAILABLE"] = "ALWAYS_AVAILABLE";
  AvailabilityType["WEEKLY_SCHEDULE"] = "WEEKLY_SCHEDULE";
  AvailabilityType["TIMESTAMP_RANGES"] = "TIMESTAMP_RANGES";
  return AvailabilityType;
}({});
//# sourceMappingURL=menu-ordering-settings.js.map